import { HoverCard } from "radix-ui";

interface NavHoverCardProps {
  title: string;
  children?: React.ReactNode;
}

export const COMMON_HOVER_CARD_PROPS: Partial<HoverCard.HoverCardProps> = {
  openDelay: 0,
  closeDelay: 0,
};

const NavHoverCard = ({ title, children }: NavHoverCardProps) => {
  return (
    <HoverCard.Content
      className="relative z-30 overflow-hidden pl-4.5"
      side="right"
      align="start"
      collisionPadding={2}
    >
      <div className="rounded-sm bg-[#18181B] p-2">
        <div className="px-2 text-label-100 text-gray-50">{title}</div>

        {children && (
          <ul className="mt-2 border-t border-[#27272A] pt-1">{children}</ul>
        )}
      </div>
    </HoverCard.Content>
  );
};

export default NavHoverCard;
